import { untracked } from '@angular/core';
import type { EntityFormSlice } from './entity-form.types';

/**
 * Replaces the signal form model from a loaded entity and clears dirty state.
 */
export function resetFormFromEntity<Entity, FormModel>(options: {
  entity: Entity | null | undefined;
  formSlice: EntityFormSlice<FormModel>;
  mapEntityToFormValue: (entity: Entity | undefined) => FormModel;
}): void {
  const { entity, formSlice, mapEntityToFormValue } = options;

  untracked(() => {
    formSlice.formModel.set(mapEntityToFormValue(entity ?? undefined));
    formSlice.entityForm().reset();
  });
}
